import { axiosInstance } from "../config/axios";

export const getTotalPoints = async () => {
  const response = await axiosInstance.get(`/guest/points`);
  return response;
};
